module.exports = "/_next/static/images/QuestThumbnail@2x-5f3ee15fadc23c6458902f14f57b2cff.png";